import { makeStyles, tokens } from '@fluentui/react-components';

export const useWorkDetailsLayout = makeStyles({
  layout: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    alignItems: 'start',
    gap: tokens.spacingVerticalL,
    '@media (min-width: 1201px)': {
      gridTemplateColumns: 'minmax(0, 1.6fr) minmax(320px, 1fr)',
      columnGap: tokens.spacingHorizontalL,
    },
  },
});
